import { render, staticRenderFns } from "./LineupPitch.vue?vue&type=template&id=0273d87a&scoped=true"
import script from "./LineupPitch.vue?vue&type=script&lang=js"
export * from "./LineupPitch.vue?vue&type=script&lang=js"
import style0 from "./LineupPitch.vue?vue&type=style&index=0&id=0273d87a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0273d87a",
  null
  
)

export default component.exports